export interface Location {
  zipcode: any;
  latitude: Number;
  longitude: Number;
}

export interface AccountData {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  originalPhoto: string;
  croppedPhoto: string;
  location: Location;
  roles: string[];
  hasPremiumHistory: boolean;
  profilePhotoStatus: string;
}

/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum AccountRoles {
  FamilyConcierge = 'com.sittercity.empire:Role.family_concierge',
  Sitter = 'com.sittercity.empire:Role.provider',
  Parent = 'com.sittercity.empire:Role.seeker',
  Premium = 'com.sittercity.empire:Role.premium_seeker',
  Corporate = 'com.sittercity.empire:Role.corporate_seeker',
  FeaturedSitter = 'com.sittercity.empire:Role.featured_provider',
}

export enum AccountTypes {
  FamilyConcierge = 'family_concierge',
  Sitter = 'sitter',
  Parent = 'basic',
  Premium = 'premium',
  Corporate = 'corporate',
  FeaturedSitter = 'featured_sitter',
}
/* eslint-enable no-unused-vars */
/* eslint-enable no-shadow */

export class Account {
  static accountType(): import('vue/types/options').PropValidator<unknown> {
    throw new Error('Method not implemented.');
  }

  id: string;

  firstName: string;

  lastName: string;

  email: string;

  originalPhoto: string;

  croppedPhoto: string;

  location: Location;

  hasPremiumHistory: boolean;

  profilePhotoStatus: string;

  roles: string[];

  constructor({
    id,
    firstName,
    lastName,
    email,
    originalPhoto,
    croppedPhoto,
    location,
    roles,
    hasPremiumHistory,
    profilePhotoStatus,
  }: AccountData) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.originalPhoto = originalPhoto;
    this.croppedPhoto = croppedPhoto;
    this.roles = roles;
    this.location = location;
    this.hasPremiumHistory = hasPremiumHistory;
    this.profilePhotoStatus = profilePhotoStatus;
  }

  isParent(): boolean {
    const parentRoles = [AccountRoles.Parent, AccountRoles.Premium, AccountRoles.Corporate];
    return !!this.roles.find((r: string) => parentRoles.includes(r as AccountRoles));
  }

  isPremium(): boolean {
    return !!this.roles.find((r: string) => r === (AccountRoles.Premium as string));
  }

  isCorporate(): boolean {
    return !!this.roles.find((r: string) => r === (AccountRoles.Corporate as string));
  }

  isSitter(): boolean {
    return !!this.roles.find((r: string) => r === (AccountRoles.Sitter as string));
  }

  isFeaturedSitter(): boolean {
    return !!this.roles.find((r: string) => r === (AccountRoles.FeaturedSitter as string));
  }

  isFamilyConcierge(): boolean {
    return !!this.roles.find((r: string) => r === (AccountRoles.FamilyConcierge as string));
  }

  isBasic(): boolean {
    return !(this.isPremium() || this.isCorporate());
  }

  accountType(): AccountTypes | null {
    if (this.isFamilyConcierge()) return AccountTypes.FamilyConcierge;
    if (this.isCorporate()) return AccountTypes.Corporate;
    if (this.isPremium()) return AccountTypes.Premium;
    if (this.isParent()) return AccountTypes.Parent;
    if (this.isFeaturedSitter()) return AccountTypes.FeaturedSitter;
    if (this.isSitter()) return AccountTypes.Sitter;
    return null;
  }
}
